import { UnableToUpdateRegistrationInfoAction } from 'helpers';

import { BackToEdit } from './BackToEdit';
import { GoToProfile } from './GoToProfile';
import { GoToResellerPlaces } from './GoToResellerPlaces';
import { OpenWppHelpCentral } from './OpenWppHelpCentral';

const PrimaryActions = {
  [UnableToUpdateRegistrationInfoAction.goToProfile]: GoToProfile,
  [UnableToUpdateRegistrationInfoAction.openWppHelpCentral]: OpenWppHelpCentral,
  [UnableToUpdateRegistrationInfoAction.backToEdit]: BackToEdit,
  [UnableToUpdateRegistrationInfoAction.goToResellerPlaces]: GoToResellerPlaces,
};

const SecondaryActions = {
  [UnableToUpdateRegistrationInfoAction.backToEdit]: BackToEdit,
  [UnableToUpdateRegistrationInfoAction.goToProfile]: GoToProfile,
};

export { PrimaryActions, SecondaryActions };
